import {Tooltip} from 'platform/components';
import {Box, HStack, Space, Text, VStack} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {isEmpty, isNotNil} from 'ramda';

import type {PhotoCheckerPhotoEvaluationSaleVehiclePhoto} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {
  getPhotoCheckerColorVariant,
  getPhotoCheckerScoreBadgeColor,
} from './utils/getPhotoCheckerColorVariant';
import {getPhotoCheckerEvalAlbumScore} from './utils/matchPhotoEval';

export type PhotoCheckerScoreBadgeProps = {
  photoCheckerEval: PhotoCheckerPhotoEvaluationSaleVehiclePhoto;
};

export function PhotoCheckerScoreBadge(props: PhotoCheckerScoreBadgeProps) {
  const photoScore = getPhotoCheckerEvalAlbumScore(props.photoCheckerEval);
  const issues = props.photoCheckerEval.issues;

  const issuesBlock =
    isNotNil(issues) && !isEmpty(issues) ? (
      <VStack spacing={1} align="flex-start">
        <Space vertical={0} />
        {issues.map((issue) => (
          <HStack key={issue} spacing={2} align="flex-start">
            <Space horizontal={0} />
            <Text size="xSmall" color="white">
              •
            </Text>
            <Text size="xSmall" color="white">
              {issue}
            </Text>
          </HStack>
        ))}
      </VStack>
    ) : undefined;

  const badgeLabel = match<number | null, string>(photoScore)
    .with(null, () => 'N/A')
    .with(Pattern.number, (score) => `${score}%`)
    .exhaustive();

  return (
    <Tooltip
      label={
        isNotNil(issuesBlock)
          ? i18n.t(`entity.photoChecker.labels.photoType.${props.photoCheckerEval.photo_type}`)
          : undefined
      }
      description={issuesBlock}
      placement="top"
    >
      <Box
        borderRadius="small"
        paddingHorizontal={2}
        paddingVertical={1}
        backgroundColor={getPhotoCheckerScoreBadgeColor(getPhotoCheckerColorVariant(photoScore))}
      >
        <Text size="xxSmall" alternative color="white">
          {badgeLabel}
        </Text>
      </Box>
    </Tooltip>
  );
}
